import React, { createContext, useReducer } from 'react';
import { modalReducer } from './reducer';
import ModalPermit from '../components/ModalPermit/ModalPermit';

export const ModalActionsContext = createContext(null);
export const ModalStateContext = createContext({});

const ModalProvider = ({ children }) => {
  const [modals, dispatch] = useReducer(modalReducer, {});

  const actions = React.useMemo(
    () => ({
      openModal: (modal, props) => dispatch({ type: 'OPEN', modal, props }),
      closeModal: (modal) => dispatch({ type: 'CLOSE', modal }),
      closeAllModals: () => dispatch({ type: 'CLOSE_ALL' }),
    }),
    []
  );

  return (
    <ModalActionsContext.Provider value={actions}>
      <ModalStateContext.Provider value={modals}>
        {children}
        <ModalPermit />
      </ModalStateContext.Provider>
    </ModalActionsContext.Provider>
  );
};

export default ModalProvider;
